<template>
  <svg fill="none" height="26" viewBox="0 0 27 26" width="27" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.83333 2.6V7.8H21.1667V2.6H23.7312C24.4314 2.6 25 3.1785 25 3.8909V24.7091C24.9997 25.0514 24.8659 25.3795 24.628 25.6215C24.3901 25.8635 24.0676 25.9997 23.7312 26H3.26883C2.93232 26 2.60959 25.864 2.37163 25.6219C2.13368 25.3798 2 25.0515 2 24.7091V3.8909C2 3.1785 2.56861 2.6 3.26883 2.6H5.83333ZM9.66667 19.5H7.11111V22.1H9.66667V19.5ZM9.66667 15.6H7.11111V18.2H9.66667V15.6ZM9.66667 11.7H7.11111V14.3H9.66667V11.7ZM18.6111 0V5.2H8.38889V0H18.6111Z" fill="white"/>
  </svg>
</template>

<script>
export default { name: "SurveyIcon" };
</script>
